import DeloitteAuthContentModel, * as deloitteAuthContentModels from './contentmodel';

// // in local context, style will be loaded via normal webpack require (direct insert into head)
// // in remote context, webpack will compile this as a string, and export as "stylesheet" from module
// import style from './style.css';

export const description = "Deloitte auth strategy is the default way to authorize via simgate."
export const ContentModels = deloitteAuthContentModels;
export const ContentModel = DeloitteAuthContentModel;



// WEBPACK FOOTER //
// ./app_modules/deloitte-auth-strategy/index.js